var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFarmacia({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1259_2069)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.6783 30.082H16.1042",
    stroke: "#FF6600",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.2036 52.0231V52.016C48.2036 46.4708 43.6908 41.9756 38.1239 41.9756H14.2437C8.67684 41.9756 4.16398 46.4708 4.16398 52.016V52.0231C4.16398 57.5682 8.67684 62.0635 14.2437 62.0635H38.1239C43.6908 62.0635 48.2036 57.5682 48.2036 52.0231Z",
    stroke: "#FF6600",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.1838 41.9756V62.0564",
    stroke: "#FF6600",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.4354 35.5427L45.1338 44.801",
    stroke: "#FF6600",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.7365 41.3344C27.7965 37.4099 27.7965 31.0544 31.7365 27.1299C33.038 25.8334 34.6083 24.9738 36.2706 24.537V18.1886C36.2706 12.6435 31.7577 8.14819 26.1908 8.14819C20.624 8.14819 16.1111 12.6435 16.1111 18.1886V41.9756H32.3801L31.7365 41.3344Z",
    stroke: "#FF6600",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.8743 43.9554L45.9898 27.1368C42.0499 23.2122 35.6696 23.2122 31.7296 27.1368C27.7897 31.0614 27.7897 37.4168 31.7296 41.3413L32.3733 41.9825H38.1241C43.6909 41.9825 48.2038 46.4778 48.2038 52.0229C48.2038 53.6858 47.7935 55.2429 47.0791 56.6239L48.6211 58.1599C52.5611 62.0845 58.9414 62.0845 62.8813 58.1599C66.8213 54.2354 66.8213 47.8799 62.8813 43.9554H62.8743Z",
    stroke: "#FF6600",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1259_2069"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 66,
    height: 58,
    fill: "white",
    transform: "translate(2 6)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFarmacia);
export default __webpack_public_path__ + "static/media/Farmacia.d1378cf67ad4fc793e4c7e1927ecdbd1.svg";
export { ForwardRef as ReactComponent };